import { ConfigurationId } from '@types';
import { Type } from 'ng-mocks';
import { FundAttributionDisplayComponent } from './fund-attribution-component.interface';
import { FundAttributionComponent } from './fund-attribution/fund-attribution.component';

export class FundAttributionConfig {
  static readonly FUND_ATTRIBUTION = new FundAttributionConfig(
    'Fund Attribution',
    FundAttributionComponent,
    ConfigurationId.GW
  );

  static allConfigs: FundAttributionConfig[] = [
    FundAttributionConfig.FUND_ATTRIBUTION,
  ];

  // returns matching config or undefined
  static getConfig(
    key: string,
    configurationName: ConfigurationId
  ): FundAttributionConfig {
    return this.allConfigs.find((config: FundAttributionConfig): boolean =>
      config.configurationName
        ? config.key === key && config.configurationName === configurationName // if config is GW or ETF specific,make sure it matches
        : config.key === key
    ); // otherwise just match on key
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<FundAttributionDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
